import Vue from 'vue'
import Vuex from 'vuex'
import axios from 'axios'
import moment from 'moment'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    
    configs: [],
    authToken: '',
    refreshToken: '',
    defaultParams: {},
    units: {},
    demoConfig: {},
    theme: 'light'

  },
  mutations: {
    
    setConfigs (state, configList) {
      state.configs = [...configList]
    },

    addConfig (state, config) {
      state.configs.forEach(function(c, index){
        if(c.configId == config.configId) {
          state.configs.splice(index,1)
          return false
        }
      })
      state.configs.push(config);      
    },

    updateParams (state, config) {
      var conf = state.configs.find(c => ( c.configId == config.configId ));

      if(typeof conf !== 'undefined')
        conf.params = config.params
    },
    
    addParam (state, param) {
      var conf = state.configs.find(c => ( c.configId == config.configId ));

      if(typeof conf !== 'undefined')
        conf.params.push(param)
    },

    setConfigParams (state, config) {
      var conf = state.configs.find(c => ( config.configId == c.configId ));
      conf['params'] = [...config.params]
    },

    setDefaultParams (state, params) {
      state.defaultParams[params.version] = params.params
    },

    setUnits (state, units) {
      state.units[units.version] = units.units
    },

    setAuthToken (state, authToken) {
      state.authToken = authToken;
      
      var expire = moment();
      expire.add('1','hour');

      var now = new Date();
      var time = now.getTime();
      time += 3600 * 1000;
      now.setTime(time);
      
      axios.defaults.headers.common['Authorization'] = 'Bearer '+authToken;
      document.cookie = 'authToken=' + authToken + '; Path=/; SameSite=Lax; expires=' + now.toUTCString();
    },
    
    setRefreshToken (state, refreshToken) {
      state.refreshToken = refreshToken;

      var expire = moment();
      expire.add('1','hour');

      var now = new Date();
      var time = now.getTime();
      time += 3600 * 1000;
      now.setTime(time);
      
      document.cookie = 'refreshToken=' + refreshToken + '; Path=/; SameSite=Lax; expires=' + now.toUTCString();
      if(refreshToken.length)
        document.cookie = 'refreshTokenExpire=' + expire.toISOString() + '; Path=/; SameSite=Lax; expires=' + now.toUTCString();
    },

    setDemoConfig (state, conf) {
      state.demoConfig = conf
    },

    setTheme (state, theme) {
      state.theme = theme
    }

  },
  actions: {
  },
  modules: {
  }
})
